
import AWSAppSyncClient, { AUTH_TYPE } from "aws-appsync";
import { config, awsConfig } from "../config";
const { aws_user_pools_web_client_id } = awsConfig

const getAuthUserId = () => localStorage.getItem(`CognitoIdentityServiceProvider.${aws_user_pools_web_client_id}.LastAuthUser`);
export const getJwtToken = () => localStorage.getItem(`CognitoIdentityServiceProvider.${aws_user_pools_web_client_id}.${getAuthUserId()}.accessToken`) || '';
export const getIdToken = () => localStorage.getItem(`CognitoIdentityServiceProvider.${aws_user_pools_web_client_id}.${getAuthUserId()}.idToken`) || '';

export const client = () => {

  return new AWSAppSyncClient({
    disableOffline: true,
    url: config.baseUrl,
    region: awsConfig.aws_appsync_region,
    auth: {
      type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
      jwtToken: getJwtToken(),
    },
  });
}